<template>
	<div class="c-health-check-tool__slide-info">
		<DsText
			html-element="h1"
			text-type="heading-3xl"
			text-style="medium"
			>{{ introModelSlide.headline }}</DsText
		>
		<template v-if="introModelSlide.description">
			<DsText
				html-element="p"
				text-style="regular"
				text-type="body-lg"
				class="c-health-check-tool__slide-description"
			>
				<span v-html="introModelSlide.description"></span>
			</DsText>
		</template>
	</div>
	<div v-if="introModelSlide.baseViewModel?.videoUrl || introModelSlide.baseViewModel?.videoPreviewImage">
		<VideoWithtextBlock
			:vm="{ ...introModelSlide }"
		></VideoWithtextBlock>
	</div>
	<slot name="list-block"></slot>
	<div>
		<div class="c-health-check-tool__slide-actions">
			<DsButtonGroup
				desktop-alignment="start"
				mobile-direction="column-reverse"
			>
				<DsButton
					variant="primary"
					:clickHandler="next"
				>
					{{ introModelSlide.continueButtonText }}
				</DsButton>
			</DsButtonGroup>
		</div>
		<div
			class="c-health-check-tool__slide-information"
			v-if="introModelSlide.informationalLabel"
		>
			<DsIcon
				v-if="introModelSlide.informationalIcon"
				:icon-name="introModelSlide.informationalIcon"
				size="xs"
			></DsIcon>
			<DsText html-element="p" text-type="body-xs">{{
				introModelSlide.informationalLabel
			}}</DsText>
		</div>
	</div>
	<Teleport to="[data-teleport-references]">
		<slot name="references"></slot>
	</Teleport>
</template>

<script>
import {
	DsText,
	DsButton,
	DsButtonGroup,
	DsIcon,
} from '@coloplast/design-system';
import VideoWithtextBlock from 'Features/Consumer/Views/VideoWithTextBlock/VideoWithTextBlock.vue';
import {
	track_start_page_view,
	track_start_page_action_click,
} from 'shared/services/tracking/healthCheckTrackingService';

export default {
	name: 'intro-ModelSlide',
	props: {
		introModelSlide: {
			type: Object,
		},
		displayCancelButton: {
			type: Boolean,
			default: true,
		},
	},

	emits: ['next'],

	components: {
		DsText,
		DsButton,
		DsButtonGroup,
		DsIcon,
		VideoWithtextBlock
	},

	methods: {
		next() {
			track_start_page_action_click();
			this.$emit('next');
		}
	},

	mounted: () => {
		track_start_page_view();
	},
};
</script>

<style scoped lang="scss">
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

.c-health-check-tool__form-label {
	margin: 0;
}

.c-health-check-tool {
	&__form {
		display: grid;
		gap: ds-space(6);
	}

	&__slide-description {
		.c-editorial__highlight--primary {
			color: ds-color('fg', 'default');
			text-decoration: underline;
		}
	}

	&__slide-info {
		margin-block-end: 0;
		padding: 0;
		text-align: start;
	}

	&__slide-actions {
		position: static;
		inline-size: 100%;

		@media (min-width: ds-breakpoint('md')) {
			inline-size: initial;
		}
	}

	&__slide-information {
		display: flex;
		gap: ds-space(4);
		margin-block-start: ds-space(8);
	}
}
</style>
